<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户账号">
                  <el-input  v-model="queryForm.userId"></el-input>
              </el-form-item>
              <el-form-item label="子用账号">
                  <el-input  v-model="queryForm.subId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserNodeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppUserNode"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppUserNode(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppUserNode(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppUserNodeList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppUserNodeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppUserNodeList"
      row-key="id"
      height='100%'
      border
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户ID"
        width="300"
      >
          <template slot-scope="scop" >
              <div v-if='scop.row.mppUser' style='font-size: 12px'>
                  <div>账号:{{ scop.row.mppUser.userName }}</div>
                  <div>手机:{{ scop.row.mppUser.userMobile }}</div>
              </div>
              <div v-else>-</div>
          </template>
      </el-table-column>

      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="nodeSort"
        label="节点排序"
        width="300"
      >
      </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="enterSort"
            label="进入顺序"
            width="300"
        >
        </el-table-column>

<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        align="center"-->
<!--        label="操作"-->
<!--        width="300"-->
<!--      >-->
<!--        <template slot-scope="scop">-->
<!--          <div class="operation">-->
<!--            <div @click="checkMppUserNode(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editMppUserNode(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteMppUserNode(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppUserNodeStates[mppUserNodeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppUserNode"
          ref="mppUserNodeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户ID"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="mppUserNode.userId"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="子用户ID"
            prop="subId"
          >
            <el-input
              size="small"
              v-model="mppUserNode.subId"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="子用户路径，从最下面到这个子用户截止"
            prop="subPath"
          >
            <el-input
              size="small"
              v-model="mppUserNode.subPath"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="直推人数"
            prop="directNumber"
          >
            <el-input
              size="small"
              v-model="mppUserNode.directNumber"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团队人数"
            prop="subTeamNumber"
          >
            <el-input
              size="small"
              v-model="mppUserNode.subTeamNumber"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="子用户的团队业绩（包含子用户）"
            prop="subTeamPerformance"
          >
            <el-input
              size="small"
              v-model="mppUserNode.subTeamPerformance"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否满足条件"
            prop="isFull"
          >
            <el-input
              size="small"
              v-model="mppUserNode.isFull"
              :disabled="mppUserNodeState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppUserNodeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppUserNodeList();
                    this.getMppUserNodeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppUserNodeList();
                    this.getMppUserNodeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户ID
                     subId: '', //子用户ID
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppUserNodeState: 'add',
                mppUserNodeStates: {
                    add: '新建环排',
                    check: '查看环排',
                    edit: '修改环排'
                },
                multipleSelection: [],
                mppUserNodeList: [],
                mppUserNode: {
                    id: '', //ID
                    userId: '', //用户ID
                    subId: '', //子用户ID
                    subPath: '', //子用户路径，从最下面到这个子用户截止
                    directNumber: '', //直推人数
                    subTeamNumber: '', //团队人数
                    subTeamPerformance: '', //子用户的团队业绩（包含子用户）
                    isFull: '', //是否满足条件
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    subId: [{ required: true, message: '子用户ID不能为空', trigger: 'blur' }],
                    subPath: [{ required: true, message: '子用户路径，从最下面到这个子用户截止不能为空', trigger: 'blur' }],
                    directNumber: [{ required: true, message: '直推人数不能为空', trigger: 'blur' }],
                    subTeamNumber: [{ required: true, message: '团队人数不能为空', trigger: 'blur' }],
                    subTeamPerformance: [{ required: true, message: '子用户的团队业绩（包含子用户）不能为空', trigger: 'blur' }],
                    isFull: [{ required: true, message: '是否满足条件不能为空', trigger: 'blur' }],
                },
                yesNoEnumList:[], // yesno枚举
            };
        },
        created() {
            this.getMppUserNodeList();
            this.getYesNo();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppUserNodeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppUserNodeList = [];
            },
            resetDialog() {
                this.mppUserNodeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      subId: '', //子用户ID
                };
                this.getMppUserNodeList();
            },
            closeDialog() {
                this.mppUserNode = {
                      userId: '', //用户ID
                      subId: '', //子用户ID
                      subPath: '', //子用户路径，从最下面到这个子用户截止
                      directNumber: '', //直推人数
                      subTeamNumber: '', //团队人数
                      subTeamPerformance: '', //子用户的团队业绩（包含子用户）
                      isFull: '', //是否满足条件
                };
            },
            submitForm() {
                if (this.mppUserNodeState == 'add') {
                    this.$refs.mppUserNodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/usernode/add`,{ ...this.mppUserNode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppUserNodeList();
                                    this.resetDialog();
                                    this.getMppUserNodeList();
                                }
                            });
                        }
                    });
                } else if (this.mppUserNodeState == 'edit') {
                    this.$refs.mppUserNodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/usernode/edit`,{ ...this.mppUserNode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppUserNodeList();
                                    this.resetDialog();
                                    this.getMppUserNodeList();
                                }
                            });
                        }
                    });
                }
            },
            addMppUserNode() {
                this.showDialog = true;
                this.mppUserNodeState = 'add';
            },
            checkMppUserNode(mppUserNodeId) {
                console.log(mppUserNodeId);
                this.currentMppUserNodeId = mppUserNodeId;

                this.getMppUserNodeById();
                this.showDialog = true;
                this.mppUserNodeState = 'check';
            },
            editMppUserNode(mppUserNodeId) {
                console.log('mppUserNode', mppUserNodeId);
                if (mppUserNodeId) {
                    this.currentMppUserNodeId = mppUserNodeId;
                    this.getMppUserNodeById();
                } else {
                    this.mppUserNode = { ...this.mppUserNode, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppUserNodeState = 'edit';
            },
            deleteMppUserNode(mppUserNodeId) {
                let ids = '';
                if (mppUserNodeId) {
                    ids = mppUserNodeId;
                } else {
                    ids = this.multipleSelection.map((mppUserNode) => mppUserNode.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/usernode/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserNodeList();
                                this.getMppUserNodeList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppUserNodeList() {
                this.resetMppUserNodeList();
                this.getMppUserNodeList();
            },
            getMppUserNodeList(query = {}) {
                this.loading = true;
                get(`/mpp/nodesansancircle/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppUserNodeList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMppUserNodeById() {
                get(`/mpp/usernode/get`,{ id: this.currentMppUserNodeId }).then((res) =>{
                    if(res.success){
                      this.mppUserNode = { ...this.mppUserNode, ...res.mppUserNode };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppUserNodeList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/usernode/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/usernode/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/usernode/importData`,formData);
              this.refreshMppUserNodeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppUserNodeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppUserNodeList();
            },

            //获取是否枚举
            getYesNo(){
                get('/mpp/utils/getEnum',{ enumType:'yes_no' }).then((res)=>{
                    if(res.success){
                        this.yesNoEnumList = res.enumList;
                    }
                })
            },

            //计算成功
            computeIsFull(type){
                for (let i = 0; i < this.yesNoEnumList.length; i++) {
                    if(type == this.yesNoEnumList[i].key){
                        return this.yesNoEnumList[i].value
                    }
                }
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
